import { useEffect, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import Select from "react-select";
import LoadingButton from "../../../components/loading/LoadingButton";
import Card from "../../../components/ui/div/Card";
import useProvince from "../../../hooks/useProvince";
import FilterShipments from "./FilterShipments";
import FilterTime from "./FilterTime";
import getCity from "../functions/getCity";

function Filter({ searchParams, set, isLoading, get }) {
  const { provinces } = useProvince({ initiate: true });
  const [cities, setCities] = useState([]);

  const getProviceOptions = () => {
    const array = [{ label: "...", value: 0 }];
    provinces.forEach(item =>
      array.push({ label: item.faName, value: item.id })
    );
    return array;
  };

  const getDefaultProvince = name => {
    const find = getProviceOptions().find(
      item => item.value === parseInt(searchParams.get(name))
    );

    return find ? find : { label: "...", value: 0 };
  };

  const city = id => {
    set({ label: "senderCity", value: 0 });
    if (id === 0) return;

    getCity(id).then(res => setCities(res));
  };

  const getCityOptions = () => {
    const array = [{ label: "...", value: 0 }];
    cities.map(item => array.push({ label: item.faName, value: item.id }));
    return array;
  };

  const getDefaultCity = name => {
    const find = getCityOptions().find(
      item => item.value === parseInt(searchParams.get(name))
    );

    return find ? find : { label: "...", value: 0 };
  };

  useEffect(() => {
    const id = searchParams.get("senderProvince");
    if (id) {
      getCity(id).then(res => setCities(res));
    }
  }, []);

  return (
    <section>
      <form
        onSubmit={e => {
          e.preventDefault();
          get();
        }}
      >
        <Card className="d-flex flex-wrap column-gap-3 row-gap-2">
          <FilterShipments value={searchParams} set={set} />

          <div className="w-100 mt-2">
            <h5 className="mb-1">فرستنده</h5>
            <div className="d-flex flex-wrap column-gap-3 row-gap-2">
              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>استان:</Form.Label>
                <Select
                  options={getProviceOptions()}
                  value={getDefaultProvince("senderProvince")}
                  isSearchable={true}
                  onChange={({ value }) => {
                    set({ label: "senderProvince", value });
                    city(value);
                  }}
                />
              </Col>

              <Col xs="12" sm="5" lg="3" xxl="2">
                <Form.Label>شهر:</Form.Label>
                <Select
                  options={getCityOptions()}
                  value={getDefaultCity("senderCity")}
                  isSearchable={true}
                  onChange={({ value }) => {
                    set({ label: "senderCity", value });
                  }}
                />
              </Col>
            </div>
          </div>

          <div className="w-100 mt-2 d-flex flex-wrap column-gap-3 row-gap-2">
            <FilterTime searchParams={searchParams} set={set} />
            <Col
              xs="12"
              sm="5"
              lg="3"
              xxl="2"
              className="d-flex justify-content-end align-items-end me-auto"
            >
              {isLoading === true && (
                <LoadingButton title="در حال دریافت" className="btn-primary" />
              )}
              {isLoading === false && <Button type="submit">فیلتر</Button>}
            </Col>
          </div>
        </Card>
      </form>
    </section>
  );
}

export default Filter;
